<template>
  <div>
    <div class="load-icon">
      <IconLoading loadingText="Authorizing..."></IconLoading>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import apiManager from '@/api';
import IconLoading from '../components/loaders/IconLoading.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const isAuthenticated = computed(() => store.getters['userStore/isAuthenticated']);

async function initialize() {
  if (isAuthenticated.value) {
    router.push({ name: 'home' });
  }
  if (route.query.code === undefined) {
    router.push({ name: 'unauthorized' });
  } else {
    try {
      await store.dispatch('userStore/getToken', route.query.code);

      if (isAuthenticated.value) {
        apiManager.analytic.add({ analyticTypeName: 'Login', analyticSource: 'Login' });
        router.push({ name: 'home' });
      } else {
        router.push({ name: 'unauthorized' });
      }
    } catch {
      router.push({ name: 'unauthorized' });
    }
  }
}

onMounted(() => {
  initialize();
});

</script>
